import { AffiliateSDK } from "./sdk";

export type {
  SDKInitConfig,
  ConversionData,
  ConversionResponse,
  DiscountInfo,
  DiscountValidationResult,
  LineItem,
} from "./types";

const sdk = new AffiliateSDK();

if (typeof window !== "undefined") {
  (window as any).AffiliateSDK = sdk;
}

export default sdk;
